import { AdVolumeEvent } from 'modules/imaSDK';
import { Signal } from '@preact/signals';

export const volumeChangedListener = (adEvent: AdVolumeEvent, muted: Signal<boolean>) => {
  muted.value = adEvent.h.h.volume === 0;
};
